/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {AddressDto} from "./addressDto.zod";
import {CountryCode} from "./countryCode.zod";
import {PhoneNumberDto} from "./phoneNumberDto.zod";

export const PartyProfileDto = zod.object({
  address: AddressDto,
  country: CountryCode,
  phone: PhoneNumberDto,
  websiteUrl: zod.string().nullable(),
});

export type PartyProfileDto = zod.input<typeof PartyProfileDto>;
export type PartyProfileDtoOutput = zod.output<typeof PartyProfileDto>;
